module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "hero"
  }, [_c('div', {
    staticClass: "hero-body"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h1', {
    staticClass: "title"
  }, [(_vm.$route.name === 'admins') ? _c('span', [_vm._v("Admins")]) : _vm._e(), _vm._v(" "), (_vm.$route.name === 'admin') ? _c('span', [_c('router-link', {
    attrs: {
      "to": {
        name: 'admins'
      }
    }
  }, [_vm._v("Admins")]), _vm._v("\n                        →\n                        " + _vm._s(_vm.getAdmin().first_name) + " " + _vm._s(_vm.getAdmin().last_name) + "\n                    ")], 1) : _vm._e(), _vm._v(" "), (_vm.$route.name === 'admin-create') ? _c('span', [_c('router-link', {
    attrs: {
      "to": {
        name: 'admins'
      }
    }
  }, [_vm._v("Admins")]), _vm._v("\n                        →\n                        New Admin\n                    ")], 1) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "container content"
  }, [_c('router-view')], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7858dbe7"}!./~/vue-loader/lib/selector.js?type=template&index=0!./vue/src/views/Admins.vue
// module id = 558
// module chunks = 0